<div class="service-history-container">
  <div class="page-header">
    <button class="back-btn" (click)="goBack()" title="Go back to dashboard">
      <mat-icon>arrow_back</mat-icon> Back to Dashboard
    </button>
    <h1>Service History</h1>
    <p class="subtitle">View your past bookings and services</p>
  </div>

  <div class="history-content">
    <!-- Statistics Cards -->
    <div class="stats-grid">
      <div class="stat-card">
        <mat-icon class="stat-icon">receipt_long</mat-icon>
        <div class="stat-info">
          <span class="stat-label">Total Services</span>
          <span class="stat-value">{{getTotalServices()}}</span>
        </div>
      </div>
      <div class="stat-card">
        <mat-icon class="stat-icon">payments</mat-icon>
        <div class="stat-info">
          <span class="stat-label">Total Spent</span>
          <span class="stat-value">${{getTotalSpent() | number:'1.2-2'}}</span>
        </div>
      </div>
      <div class="stat-card">
        <mat-icon class="stat-icon">star</mat-icon>
        <div class="stat-info">
          <span class="stat-label">Average Rating</span>
          <span class="stat-value">{{getAverageRating()}}</span>
        </div>
      </div>
    </div>

    <!-- Filters and Search -->
    <div class="filters-section">
      <div class="search-box">
        <input type="text" 
               [(ngModel)]="searchTerm"
               (input)="onSearchChange(searchTerm)"
               placeholder="Search services..."
               title="Search by service name or provider">
      </div>

      <div class="filter-buttons">
        <button *ngFor="let option of filterOptions"
                class="filter-btn"
                [class.active]="selectedFilter === option.value"
                (click)="onFilterChange(option.value)"
                [title]="'Filter by ' + option.label">
          {{option.label}}
        </button>
      </div>
    </div>

    <!-- Service History List -->
    <div class="history-list">
      <div class="service-item" *ngFor="let service of filteredHistory">
        <div class="service-header">
          <div class="service-title">
            <h3>{{service.serviceName}}</h3>
            <span class="service-provider">by {{service.providerName}}</span>
          </div>
          <div class="service-meta">
            <span class="status" [class]="'status-' + service.status">{{service.status | titlecase}}</span>
            <span class="recurring-badge" *ngIf="service.isRecurring" title="This is a recurring service">
              Recurring
            </span>
          </div>
        </div>

        <div class="service-details">
          <div class="detail-item">
            <span class="detail-label">Date:</span>
            <span class="detail-value">{{service.date | date:'MMM dd, yyyy'}}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Duration:</span>
            <span class="detail-value">{{service.duration}}</span>
          </div>
          <div class="detail-item" *ngIf="service.status === 'completed'">
            <span class="detail-label">Price:</span>
            <span class="detail-value price">${{service.price | number:'1.2-2'}}</span>
          </div>
          <div class="detail-item" *ngIf="service.status === 'cancelled'">
            <span class="detail-label">Reason:</span>
            <span class="detail-value">{{service.reason}}</span>
          </div>
        </div>

        <!-- Review Section -->
        <div class="review-section" *ngIf="service.status === 'completed' && service.rating">
          <div class="rating">
            <span class="stars">
              <mat-icon class="star" *ngFor="let i of [1,2,3,4,5]" [class.filled]="i <= service.rating">star</mat-icon>
            </span>
            <span class="rating-value">{{service.rating}}/5</span>
          </div>
          <p class="review-text" *ngIf="service.review">{{service.review}}</p>
        </div>

        <!-- Next Schedule Info -->
        <div class="next-schedule" *ngIf="service.isRecurring && service.nextSchedule">
          <span class="schedule-label">Next scheduled:</span>
          <span class="schedule-date">{{service.nextSchedule | date:'MMM dd, yyyy'}}</span>
        </div>
      </div>

      <!-- Empty State -->
      <div class="empty-state" *ngIf="filteredHistory.length === 0">
        <mat-icon class="empty-icon">inbox</mat-icon>
        <p class="empty-title">No Services Found</p>
        <p class="empty-description" *ngIf="searchTerm || selectedFilter !== 'all'">
          Try adjusting your filters or search term
        </p>
        <p class="empty-description" *ngIf="!searchTerm && selectedFilter === 'all'">
          You haven't booked any services yet
        </p>
      </div>
    </div>
  </div>
</div>
